import {RxGroupProperty} from '../../../../../../../../common/model/db/types/RxGroupProperty';
import {workflowPropertyNameRegex} from './workflowPropertyNameRegex';

export function getWorkflowPropertyDefaultValue(row: RxGroupProperty) {
    return row?.property_ref?.name?.match(workflowPropertyNameRegex)?.[2];
}
